import React, { Suspense, lazy } from 'react';
import './App.css';
import {
  Route,
  BrowserRouter as Router,
  Routes as Switch,
} from "react-router-dom";
import Footer from "./components/core/Footer";
import ScrollToTop from "./components/helper/ScrollToTop";

// Lazy load views
const Home = lazy(() => import("./views/Home"));
const AboutMe = lazy(() => import("./views/AboutMe"));
const Treatment = lazy(() => import("./views/Treatment"));
const Gallery = lazy(() => import("./views/Gallery"));
const NotFound = lazy(() => import("./views/NotFound"));
const Questionnaire = lazy(() => import("./views/Questionnaire"));
const ThankYou = lazy(() => import("./views/ThankYou"));
const Impressum = lazy(() => import("./views/Impressum"));
const PrivacyPolicy = lazy(() => import("./views/PrivacyPolicy"));
const ContactThankYou = lazy(() => import("./views/ContactThankYou"));
const Blog = lazy(() => import("./views/Blog"));
const Price = lazy(() => import("./views/Price"));
const BlogDetails = lazy(() => import("./components/blog/BlogDetails"));
const TreatmentDetails = lazy(() => import("./components/treatment/TreatmentDetails"));

function App() {

  return (
      <>
        <Router>
          <ScrollToTop />
          <Suspense fallback={<div className="min-h-screen flex items-center justify-center">Loading...</div>}>
            <Switch>
                <Route exact path="/" element={<Home />} />
                <Route path="/rolam" element={<AboutMe />} />
                <Route path="/kezelesek" element={<Treatment />} />
                <Route path="/kezelesek/:slug" element={<TreatmentDetails />} />
                <Route path="/galeria" element={<Gallery />} />
                <Route path="/borapolasi-kerdoiv" element={<Questionnaire />} />
                <Route path="/sikeres-feliratkozas" element={<ThankYou />} />
                <Route path="/koszonjuk" element={<ContactThankYou />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:excerpt" element={<BlogDetails />} />
                <Route path="/impresszum" element={<Impressum />} />
                <Route path="/adatvedelmi-tajekoztato" element={<PrivacyPolicy />} />
                <Route path="/araink" element={<Price />} />
                <Route path="*" element={<NotFound />} />
                <Route path="/404" element={<NotFound />} />
            </Switch>
          </Suspense>
          <Footer />
        </Router>
      </>
  );
}

export default App;
